import React, { useCallback, useEffect, useState } from 'react';

import { Row, TableView } from '~components/table-view';

import accountCodesColumns from '~support-at-home/forms/settings/AccountCodesList';

import {
  useDeleteAccountCodeMutation,
  useGetAccountCodesQuery,
  useUpsertAccountCodeMutation,
} from '~support-at-home/actions/accountCodes';

interface ComponentProps {
  isActive: boolean;
}

const AccountCodes: React.FC<ComponentProps> = ({ isActive }) => {
  const { data: accountCodesData, refetch } = useGetAccountCodesQuery(undefined, { skip: !isActive });
  const accountCodes = accountCodesData ?? [];
  const [upsertAccountCode] = useUpsertAccountCodeMutation();
  const [deleteAccountCode] = useDeleteAccountCodeMutation();

  const [data, setData] = useState<Row[]>(accountCodes);

  const load = useCallback(async () => {
    await refetch();
  }, [refetch]);

  const handleChange = (rows: Row[]) => {
    setData(rows);
  };

  const handleSaveRow = async (row: Row) => {
    // Clean rows for upserting
    const { createdby_id, updatedby_id, created_at, updated_at, ...cleanRow } = row;

    const payload = await upsertAccountCode({
      ...cleanRow,
      id: typeof cleanRow.id === 'number' ? String(cleanRow.id) : cleanRow.id,
    }).unwrap();
    if (payload?.success) {
      load();
    }
  };

  const handleDelete = async (rowId: string | number) => {
    if (!rowId) return;

    const existing = accountCodes.some(({ id }) => id === rowId);

    if (!existing) {
      setData((prev) => prev.filter((row) => row.id !== rowId));
      return;
    }

    const payload = await deleteAccountCode({ id: String(rowId) }).unwrap();
    if (payload?.success) {
      load();
    }
  };

  useEffect(() => {
    setData(accountCodesData ?? []);
  }, [accountCodesData]);

  useEffect(() => {
    if (isActive) {
      load();
    }
  }, [isActive]);

  return (
    <div>
      <div className="p-2">
        <TableView
          id="accounts-codes-table"
          columns={accountCodesColumns}
          data={data}
          onChange={handleChange}
          onDeleteRow={handleDelete}
          emptyMessage={'No items found'}
          onSaveRow={handleSaveRow}
        />
      </div>
    </div>
  );
};

export default AccountCodes;
